import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import PdfViewer from '@monorepo/shared/src/components/common/Pdf/PdfViewer';
import type {
  Maybe,
  Page as PageType,
} from '@monorepo/shared/src/graph/schema-generated-types-student';

type Props = {
  pdfUrl: Maybe<string> | undefined;
  pages: Maybe<PageType[]> | undefined;
  printRef: any;
};

const PageForPrint: React.FC<Props> = ({ pdfUrl, pages = [], printRef }) => {
  const arrayOfPages = useCallback(() => {
    return pages?.map((p) => p.pageNumber ?? 0);
  }, [pages]);

  return (
    <Box display="none">
      <PdfViewer url={pdfUrl ?? ''} printRef={printRef} pageNumbers={arrayOfPages()} printPreview />
    </Box>
  );
};

export default PageForPrint;
